export const yodaCustomerConstants = {
  GETALL_REQUEST: "YODACUSTOMER_GETALL_REQUEST",
  GETALL_SUCCESS: "YODACUSTOMER_GETALL_SUCCESS",
  GETALL_FAILURE: "YODACUSTOMER_GETALL_FAILURE",

  GETONE_REQUEST: "YODACUSTOMER_GETONE_REQUEST",
  GETONE_SUCCESS: "YODACUSTOMER_GETONE_SUCCESS",
  GETONE_FAILURE: "YODACUSTOMER_GETONE_FAILURE",
};
